import React, { useEffect, useState } from "react";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { getGroupColor } from "../../../theme/groupingColors";
import "./clashing.scss";

function SolvedClash(props) {
  const { 
    currentVal, 
    currentGroup, 
    newVal, 
    newGroup, 
    solution,
    currentHardMax,
    incomingHardMax,
    currentHardMin,
    incomingHardMin,
    currentFixed,
    incomingFixed,
    conflicts = []
  } = props;
  const [solutionIcon, setSolutionIcon] = useState(null);

  useEffect(() => {
    switch (solution) {
      case "CURRENT_STAYS":
        setSolutionIcon(
          <div title="Current value chosen">
            <EastIcon className="solutionIcon" />
          </div>
        );
        break;
      case "NEW_STAYS":
        setSolutionIcon(
          <div title="Incoming value chosen">
            <WestIcon className="solutionIcon" />
          </div>
        );
        break;
      case "NEW_GROUP":
        setSolutionIcon(
          <div title="Changed groups">
            <LinkOffIcon className="solutionIcon" />
          </div>
        );
        break;

      default:
        break;
    }
  }, []);

  const renderConflictDetails = () => {
    // Ensure conflicts is an array before using array methods
    const conflictsArray = Array.isArray(conflicts) ? conflicts : [];
    
    if (conflictsArray.length === 0) {
      return null;
    }

    return (
      <div className="conflictDetails">
        {conflictsArray.includes('value') && (
          <div className="conflictProperty">
            <div className="propertyTitle">Value:</div>
            <div className="propertyValues">
              <span>{currentVal !== undefined ? currentVal : "Not set"}</span> → 
              <span>{newVal !== undefined ? newVal : "Not set"}</span>
            </div>
          </div>
        )}
        
        {conflictsArray.includes('hardMax') && (
          <div className="conflictProperty">
            <div className="propertyTitle">Hard Max:</div>
            <div className="propertyValues">
              <span>{currentHardMax !== undefined ? currentHardMax : "Not set"}</span> → 
              <span>{incomingHardMax !== undefined ? incomingHardMax : "Not set"}</span>
            </div>
          </div>
        )}
        
        {conflictsArray.includes('hardMin') && (
          <div className="conflictProperty">
            <div className="propertyTitle">Hard Min:</div>
            <div className="propertyValues">
              <span>{currentHardMin !== undefined ? currentHardMin : "Not set"}</span> → 
              <span>{incomingHardMin !== undefined ? incomingHardMin : "Not set"}</span>
            </div>
          </div>
        )}
        
        {conflictsArray.includes('fixed') && (
          <div className="conflictProperty">
            <div className="propertyTitle">Fixed:</div>
            <div className="propertyValues">
              <span>{currentFixed !== undefined ? String(currentFixed) : "Not set"}</span> → 
              <span>{incomingFixed !== undefined ? String(incomingFixed) : "Not set"}</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="solvedClash">
      <div className="conflictGroups">
        <div
          className="value"
          style={{ backgroundColor: getGroupColor(currentGroup) }}
          title={`Group: ${currentGroup} - Value: ${currentVal}`}
        >
          {currentGroup}
        </div>
        {solutionIcon}

        <div
          className="value"
          style={{ backgroundColor: getGroupColor(newGroup) }}
          title={`Group: ${newGroup} - Value: ${newVal}`}
        >
          {newGroup}
        </div>
      </div>
      
      {renderConflictDetails()}
    </div>
  );
}

export default SolvedClash;
